<template>
  <svg
    width="64"
    height="65"
    viewBox="0 0 64 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17471_95704)">
      <path
        d="M31.9997 64.4993C49.6726 64.4993 63.9993 50.1726 63.9993 32.4997C63.9993 14.8267 49.6726 0.5 31.9997 0.5C14.3267 0.5 0 14.8267 0 32.4997C0 50.1726 14.3267 64.4993 31.9997 64.4993Z"
        fill="#135F7C"
      />

      <path
        d="M47.1976 21.1208C49.1878 17.9957 48.2678 13.849 45.1429 11.8589C42.0179 9.86888 37.8712 10.789 35.8811 13.9142L16.798 43.8802C14.8078 47.0053 15.7278 51.152 18.8527 53.1421C21.9777 55.1321 26.1243 54.212 28.1145 51.0869L47.1976 21.1208Z"
        fill="white"
      />
    </g>

    <defs>
      <clipPath id="clip0_17471_95704">
        <rect
          width="64"
          height="64"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'ZmartaSymbolColor'
  }
</script>
